import request from '@/utils/request'


// 查询用户头像列表
export function listUserAvatar(query) {
  return request({
    url: '/user/user-avatar/list',
    method: 'get',
    params: query
  })
}

// 查询用户头像分页
export function pageUserAvatar(query) {
  return request({
    url: '/user/user-avatar/page',
    method: 'get',
    params: query
  })
}

// 查询用户头像详细
export function getUserAvatar(data) {
  return request({
    url: '/user/user-avatar/detail',
    method: 'get',
    params: data
  })
}

// 新增用户头像
export function addUserAvatar(data) {
  return request({
    url: '/user/user-avatar/add',
    method: 'post',
    data: data
  })
}

// 修改用户头像
export function updateUserAvatar(data) {
  return request({
    url: '/user/user-avatar/edit',
    method: 'post',
    data: data
  })
}

// 删除用户头像
export function delUserAvatar(data) {
  return request({
    url: '/user/user-avatar/delete',
    method: 'post',
    data: data
  })
}
